module.exports = __webpack_public_path__ + "img/bg_image.ac6f9c3a.jpg";